import React from 'react';

import { useFormContext } from 'react-hook-form';

import PropTypes from 'prop-types';

import ForecastCategoryCleanModal from '../../../modals/tag/clean';
import { getTransactions } from '../../../utils/operations';

const CleanModalWrapper = (props) => {
	const { children, onClose, open, ...rest } = props;

	const { getValues, setValue } = useFormContext();

	const onSubmit = React.useCallback(
		(event, { type, tagId }) => {
			const operations = getTransactions(
				{
					type,
					tagId,
				},
				{ getValues },
			);

			const changes = operations.map((operation) => {
				return {
					op: 'REMOVE',
					payload: { targetId: operation._id },
				};
			});

			const existingChanges = getValues('changes') ?? [];
			setValue('changes', [...existingChanges, ...changes]);

			return onClose?.(event);
		},
		[getValues, onClose, setValue],
	);

	return (
		<>
			<ForecastCategoryCleanModal
				open={open}
				onClose={onClose}
				onSubmit={onSubmit}
				{...rest}
			/>
			{children}
		</>
	);
};

CleanModalWrapper.displayName = 'CleanModalWrapper';
CleanModalWrapper.propTypes = {
	children: PropTypes.node,
	onAction: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool,
};

export default CleanModalWrapper;
